import script from "./CategoriesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesPage.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesPage.vue?vue&type=style&index=0&id=1bcfa523&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bcfa523"]])

export default __exports__